import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { history } from "./helpers/history";
import { BrowserRouter } from "react-router-dom";

import { FaUserPlus, FaUsers, FaListUl, FaShoppingCart, FaRegDotCircle, FaChartBar, FaFileUpload } from 'react-icons/fa'
import {HiOutlineViewGridAdd, HiHome, HiOutlineLink} from 'react-icons/hi'
import {RiProfileFill} from 'react-icons/ri'
import PropTypes from 'prop-types';

import { clearMessage } from "./actions/message-action";
import TopNavBar from './components/TopNavBar/TopNavBar';
import {Sidebar, NavItemsContainer, NavItem} from './components/SideNavBar'
import { WEB_AUTH_URL, WEB_CORE_URL } from "./configurations/paths.config";
import { onGoToSG3PlusClick } from "./common/Helpers";
import AuthService from './services/auth.service'
import { Pages } from './pages/routers/Pages'

import 'bootstrap/dist/css/bootstrap.min.css';
import "./css/App.css";
import "office-ui-fabric-react/dist/css/fabric.css";

const Layout = (props) => {
  const { t } = useTranslation();

  const { user: currentAuth } = useSelector((state) => state.auth);

  //Redireccion si por alguna razon existe skh en url erronea.//
  const skh = new URLSearchParams(window.location.search).get('skh');
  if (skh !== null && skh !== undefined && window.location.href.toString().toLowerCase().indexOf("/ssolistener?") === -1) {
    window.location.replace(`${WEB_AUTH_URL}/ssolistener?skh=${skh}`)
  }

  const dispatch = useDispatch();

  useEffect(() => {
    history.listen((location) => {
      dispatch(clearMessage());
    });
  }, [dispatch]);
  
  const logOut = () => {
    AuthService.logout(WEB_CORE_URL, true, currentAuth.userName);
  };

  const getAuthRoleName = (userProfile) => {
    if (userProfile.isSAdmin) {
      return "sAdmin"
    }
    else {
      return (userProfile.isAdmin ? "Admin" : "User")
    }
  } 

  return (
    <BrowserRouter>
        {
        currentAuth !== null && window.location.href.indexOf('?RedirectUrl=cb') === -1 &&
        <Sidebar expand={false} defaultExpanded={false}>
            <NavItemsContainer>
                <NavItem icon={<HiHome/>} to='/profile' state={{ userName: currentAuth.userName }} label={t('data-lang-sidenavbar-home')} exact />
                {(props.profile.isSAdmin)  &&
                  <NavItem icon={<FaChartBar/>} to='/profilesadmin' label={t('data-lang-sidenavbar-sadmin-profile')} exact /> 
                }
                {(props.profile.isAdmin)  &&
                  <NavItem icon={<RiProfileFill/>} to='/profileclient' label={t('data-lang-sidenavbar-client-profile')} exact />
                }
                {(props.profile.isSAdmin || props.profile.isAdmin)  &&
                  <NavItem label={t('data-lang-sidenavbar-users')}>
                    <NavItem icon={<FaUserPlus/>} to='/createuser' label={t('data-lang-sidenavbar-users-add')} exact />
                    <NavItem icon={<FaFileUpload/>} to='/bulkcreateuser' label={t('data-lang-sidenavbar-users-bulk')} exact />
                    <NavItem icon={<FaUsers/>} to='/listusers' state={{ authRoleName: getAuthRoleName(props.profile) }} label={t('data-lang-sidenavbar-users-list')} exact />
                  </NavItem>
                }
                {props.profile.isSAdmin &&
                <NavItem label={t('data-lang-sidenavbar-clients')}>
                  <NavItem icon={<HiOutlineViewGridAdd/>} to='/createclient' label={t('data-lang-sidenavbar-clients-add')} exact />
                  <NavItem icon={<FaListUl/>} to='/listclients' label={t('data-lang-sidenavbar-clients-list')} exact />
                </NavItem>
                }
                {(props.profile.isAdmin)  &&
                  <NavItem icon={<FaShoppingCart/>} to='/manageproducts' label={t('data-lang-sidenavbar-manageproducts')} exact />
                }
                <NavItem icon={<FaRegDotCircle/>} to='/whitepage' onClick={()=> onGoToSG3PlusClick()} label={t('data-lang-sg3plus')} exact />
                
            </NavItemsContainer>
        </Sidebar>
        }
        <main>        
          {
            currentAuth  && window.location.href.indexOf('?RedirectUrl=cb') === -1 && <TopNavBar exportAsImage={props.exportAsImage2} logOut={logOut} currentAuth={currentAuth} />
          }
          <div style={{marginTop: "-150px"}} className="container-flex px-2">
            <Pages />
          </div>
        </main>
    </BrowserRouter>
  );
};
Layout.propTypes = {
  profile: PropTypes.object.isRequired,
  exportAsImage2: PropTypes.func.isRequired,
};        
export default Layout;
            